import { render, staticRenderFns } from "./TLessonContent.vue?vue&type=template&id=20b57b9b&"
import script from "./TLessonContent.vue?vue&type=script&lang=js&"
export * from "./TLessonContent.vue?vue&type=script&lang=js&"
import style0 from "./TLessonContent.vue?vue&type=style&index=0&id=20b57b9b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports